import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';

class PartLink extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const {part, description, partCode, finalDate, initialDate, dealer, agency, user, reason} = this.props;
    this.props.getPartLostSalesDetail(
      {description, 'partCode': part},
      {partCode, finalDate, initialDate, dealer, agency, user, reason}
    );
  }

  render() {
    return (
      <a onClick={this.handleClick}>{this.props.part}</a>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'initialDate': state.lostSalesReportDetail.initialDate,
    'finalDate': state.lostSalesReportDetail.finalDate,
    'dealer': state.lostSalesReportDetail.dealer,
    'agency': state.lostSalesReportDetail.agency,
    'user': state.lostSalesReportDetail.user,
    'reason': state.lostSalesReportDetail.reason,
    'partCode': state.lostSalesReportDetail.partCode,
  };
};

const {getPartLostSalesDetail} = Actions;

export default connect(mapStateToProps, {getPartLostSalesDetail})(PartLink);
